import { useTranslation } from 'react-i18next';
import { IndustryType } from '../types';
import industryTypes from '../helpers/hardcodedIndustryTypes';

const useIndustryTypes = () => {
  const { t } = useTranslation();

  const industryTypesOptions = industryTypes.map((type: IndustryType) => ({
    value: type.IndustryTypeId.toString(),
    label: t(`industryTypes.type${type.IndustryTypeId}`),
  }));

  return {
    industryTypes,
    industryTypesOptions
  };
};

export default useIndustryTypes;
